module.exports = __webpack_public_path__ + "static/media/stofferingen-10.fbd406de.jpg";